module.exports = {
    props: [],
    data() {
        return {
            $scroller: null,
            scrollLeft: 0,
            scrollerWidth: 0,
            scrollWidth: 0,
            slideWidth: 0,
            width: 0,
            ulPad: 80,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        canScrollNext() {
            return this.scrollLeft + this.width + this.ulPad < this.scrollWidth - 2;
        },
        canScrollPrev() {
            return this.scrollLeft > 1;
        },
        isPaged() {
            if (this.$refs.scroller) {
                return this.scrollWidth - this.ulPad > this.width;
            }
            return this.scrollWidth > this.width;
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.load();
        });
    },
    updated() {
        this.$nextTick(() => {
            this.load();
        });
    },
    methods: {
        getScrollPosition(direction) {
            if (this.slideWidth < this.width) {
                // Check if container is a <ul> with <li> children
                const isListContainer = this.$refs.scroller &&
                    this.$refs.scroller.tagName === 'UL' &&
                    this.$refs.scroller.children.length > 0 &&
                    this.$refs.scroller.children[0].tagName === 'LI';

                if (isListContainer) {
                    // Calculate number of visible items
                    const visibleItems = Math.floor(this.width / this.slideWidth);
                    // Scroll by (visible items - 1) to keep one item in view for context
                    const itemsToScroll = Math.max(1, visibleItems - 1);
                    return this.scrollLeft + ((direction ? 1 : -1) * (itemsToScroll * this.slideWidth));
                }

                return this.scrollLeft +
                    ((direction ? 1 : -1) * (Math.floor(this.width / this.slideWidth) * this.slideWidth));
            }
            return this.scrollLeft + ((direction ? 1 : -1) * this.width);
        },
        load() {
            if (this.$refs.scroller === undefined) {
                return;
            }
            this.measureAll();
            window.addEventListener('resize', this.windowResize, false);
            window.addEventListener('scroll', this.windowScroll, false);
            this.$refs.scroller.addEventListener('scroll', this.measureScrollPosition, false);
            this.windowScroll();
        },
        measureAll() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.width = $(this.$refs.scroller).width();
            this.slideWidth = $(this.$refs.scroller.children[0]).outerWidth(true);
            this.scrollWidth = this.$refs.scroller.scrollWidth;
            this.measureScrollPosition();
        },
        measureScrollPosition() {
            this.scrollLeft = this.$refs.scroller.scrollLeft;
        },
        scroll(dir) {
            if ((dir && !this.canScrollNext) || (!dir && !this.canScrollPrev)) {
                return;
            }
            $(this.$refs.scroller).animate({scrollLeft: this.getScrollPosition(dir)}, 300, this.measureScrollPosition);
        },
        windowResize() {
            clearInterval(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.measureAll();
            }, 300);
        },
        windowScroll() {
            if (this.$refs.scroller.getBoundingClientRect().top < this.windowHeight * 1.5) {
                window.removeEventListener('scroll', this.windowScroll, false);
            }
        },
    },
};
